import { Component } from 'react';

export default class MissingImageIcon extends Component {
  render() {
    return (
      <svg x="0px" y="0px" width="42px" height="42px" viewBox="0 0 42 42">
        <path
          fill="#FAF8F8"
          d="M28,26.23l-4.17-4.181l-1.96,1.97l1.51,1.51l-0.7,0.621L22.62,26h0.03c-1.864-2-0.654-0.554-6.21-6.11 L14,22.41V14h10v4h6l-6-6H12v18h18V20h-2V26.23z"
        />
      </svg>
    );
  }
}
